// Copyright (c) 2017 Deere & Company

import Report from '../state/report';
import {getDefaultState} from '../state';
import openPipProgramsReportActions from '../actions-list';
import sharedActions from '../../actions-list';

const createOpenPipProgramsReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().report, action) => {

    const actionTypes = {
        [sharedActions.RESET_REPORT_SEARCH_RESULTS]: createOpenPipProgramsReport,
        [openPipProgramsReportActions.UPDATE_OPEN_PIP_PROGRAMS_REPORT]: createOpenPipProgramsReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/reducers/report.js